import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import helper from 'helpers/steinerHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/dashboardCommerciali';

const routes = helper.generateRoutes('dashboardCommerciali', selectors);

routes.list.list.breadcrumb = `Dashboard`;

const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'dashboardCommerciali' */ `modules/dashboardCommerciali/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('dashboardCommerciali', routes.patterns);
routeRegister.addLinks('dashboardCommerciali', links);

export default list;